import { sanitizeCustomHtml } from "@redotech/order-tracking-common/sanitize-custom-html";
import { RichTextElement } from "@redotech/redo-content-builder-common/forge/review-forge-types";
import htmlReactParser from "html-react-parser";
import { memo } from "react";

export const RichText = memo(function RichText({
  element,
}: {
  element: RichTextElement;
}) {
  const containerId = `container-${element.id}`;
  return (
    <>
      <style>
        {`#${containerId} a {
          color: ${element.linkColor};
        }`}
      </style>
      <div
        id={containerId}
        style={{
          color: element.textColor,
          fontSize: element.fontSizePx,
          fontFamily: element.fontFamily,
          border: "none",
          lineHeight: 1.42, // match Quill Editor
        }}
      >
        {/* Merchant-authored (updateReviewForm) HTML renders in the builder on
            app.getredo.com and for shoppers, so sanitize at the sink. */}
        {htmlReactParser(sanitizeCustomHtml(element.html))}
      </div>
    </>
  );
});
